import { useContext, useState } from 'react';

import ShowMore from 'components/ShowMore';
import { TranslationContext } from 'context/translationContext';

import styles from './styles.module.scss';

const WebsitesDescription = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useContext(TranslationContext);

  const toggleOpen = () => {
    setIsOpen(prevState => !prevState);
  };

  return (
    <div>
      <span>{t('websitesClaim')}</span>
      <br />
      <br />
      <ul>
        <li>{t('websitesAdvantage1')}</li>
        <li>{t('websitesAdvantage2')}</li>
        <li>{t('websitesAdvantage3')}</li>
      </ul>
      {isOpen && (
        <>
          <br />
          <p>{t('websitesDescription1')}</p>
          <div className={styles.exampleslist}>
            <b>Przykłady:</b>
            <ul>
              <li>
                <a href="http://theview.com.pl" target="_blank">
                  The View Hotel
                </a>
              </li>
              <li>
                <a href="http://radissonmiedzywodzie.pl" target="_blank">
                  Radisson Blu Międzywodzie
                </a>
              </li>
            </ul>
          </div>
          <br />
        </>
      )}
      <ShowMore isOpen={isOpen} handleClick={toggleOpen} />
    </div>
  );
};

export default WebsitesDescription;
